module.exports = __webpack_public_path__ + "static/media/setting-icon.5fa2522b.svg";